import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'

import NProgress from "nprogress";
import "nprogress/nprogress.css";
import "./plugins/element.js";
import "./assets/css/base.css";

import { parseTime, resetForm, addDateRange, selectDictLabel, selectDictLabels, handleTree } from "@/utils/ruoyi";

Vue.prototype.parseTime = parseTime


// 引入cookies
import VueCookies from "vue-cookies";

import FilePreview from './views/FilePreview.vue'

Vue.component('FilePreview', FilePreview)

const mobileUnavailablePath = '/mobile-unavailable'

const whiteList = ['/login', '/register', '/legal'];// 不重定向白名单

whiteList.push(mobileUnavailablePath)
Vue.config.productionTip = false


import download from '@/plugins/download'

import { getToken } from '@/utils/auth'

Vue.prototype.$download = download

function isMobileOrTablet() {
  const ua = navigator.userAgent || ''
  const isMobile = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(ua)
  const isIPad = /iPad/i.test(ua)
  const isIPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
  const isAndroidTablet = /Android/i.test(ua) && !/Mobile/i.test(ua)

  return isMobile || isIPad || isIPadOS || isAndroidTablet
}



//路由守卫
router.beforeEach((to, from, next) => {
  if (isMobileOrTablet()) {
    if (to.path === mobileUnavailablePath) {
      next()
    } else {
      next(mobileUnavailablePath)
    }
    NProgress.done()
    return
  }

  if (to.path === mobileUnavailablePath) {
    next({ path: "/" })
    NProgress.done()
    return
  }

  if (getToken()) {
    if (to.path === "/login") {
      next({ path: "/" });
      NProgress.done(); // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      // 获取用户余额（如果还没有获取过）
      if (!store.getters.balance || store.getters.balance === "0.00") {
        store.dispatch("GetBalance").catch(() => {});
      }
      next();
      NProgress.done();
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next("/login");
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
